/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAssetComponentRequestDto
 */
export interface CreateAssetComponentRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAssetComponentRequestDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetComponentRequestDto
     */
    assetContextId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetComponentRequestDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetComponentRequestDto
     */
    parentComponentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetComponentRequestDto
     */
    componentClassId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateAssetComponentRequestDto
     */
    installedAt?: Date | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateAssetComponentRequestDto
     */
    attributes?: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the CreateAssetComponentRequestDto interface.
 */
export function instanceOfCreateAssetComponentRequestDto(value: object): value is CreateAssetComponentRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('assetContextId' in value) || value['assetContextId'] === undefined) return false;
    return true;
}

export function CreateAssetComponentRequestDtoFromJSON(json: any): CreateAssetComponentRequestDto {
    return CreateAssetComponentRequestDtoFromJSONTyped(json, false);
}

export function CreateAssetComponentRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssetComponentRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'assetContextId': json['assetContextId'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'parentComponentId': json['parentComponentId'] == null ? undefined : json['parentComponentId'],
        'componentClassId': json['componentClassId'] == null ? undefined : json['componentClassId'],
        'installedAt': json['installedAt'] == null ? undefined : (new Date(json['installedAt'])),
        'attributes': json['attributes'] == null ? undefined : json['attributes'],
    };
}

export function CreateAssetComponentRequestDtoToJSON(json: any): CreateAssetComponentRequestDto {
    return CreateAssetComponentRequestDtoToJSONTyped(json, false);
}

export function CreateAssetComponentRequestDtoToJSONTyped(value?: CreateAssetComponentRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'assetContextId': value['assetContextId'],
        'serialNumber': value['serialNumber'],
        'parentComponentId': value['parentComponentId'],
        'componentClassId': value['componentClassId'],
        'installedAt': value['installedAt'] == null ? value['installedAt'] : value['installedAt'].toISOString(),
        'attributes': value['attributes'],
    };
}

